import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { useSeo } from "@/hooks/useSeo";

export function NotFoundPage() {
  useSeo({
    title: "Page Not Found | Hive Homes Dubai",
    description:
      "The page you requested could not be found. Return to Hive Homes Dubai.",
  });

  return (
    <div className="container-wide flex flex-col items-center gap-5 py-20 text-center sm:gap-6 sm:py-32 short:py-12">
      <p className="eyebrow text-[var(--cream)]">404</p>
      <p
        className="font-display text-[64px] leading-none text-[var(--text)] sm:text-[88px] md:text-[180px]"
        style={{ fontVariationSettings: '"opsz" 96' }}
      >
        Not found.
      </p>
      <p className="max-w-md text-[14.5px] text-[var(--text-soft)] sm:text-base">
        This page may have moved, or the link has changed. Let's get you back
        on the right path.
      </p>
      <Link to="/" className="btn btn-ghost mt-2">
        <ArrowLeft className="size-4" />
        Back home
      </Link>
    </div>
  );
}
